import BookIcon from "@svg/new-design/book";
import CircleClock from "@svg/new-design/circle-clock";
import Graduated from "@svg/new-design/graduated";
import ImageComponent from "@shared/components/image";
import CollectionFrame from "assets/image/CollectionFrame";
import { IHowToLearnDetailInput } from "../types";
import HowToLearnDetailContent from "./DetailContent";
import DetailHeaderItem from "./DetailHeaderItem";
import { resolveThumbnailSources } from "utils/product-image";

interface Props {
  productCollection: IHowToLearnDetailInput;
}

const HowToLearnDetailHeader: React.FC<Props> = ({ productCollection }) => {
  const imageSources = resolveThumbnailSources({
    svg_image: productCollection?.data?.svg_image,
    png_image: productCollection?.data?.png_image,
  });

  return (
    <div className="px-4 md:px-6 md:mb-8 mt-6 md:mt-0 mb-4 lg:px-10 xl:px-0 xl:max-w-[1200px] mx-auto  w-full       ">
      <div className=" w-full">
        <div className=" flex-col w-full flex md:flex-row lg:gap-x-12 gap-x-6">
          <div className=" collectionHeaderFrame grow shrink-0  relative   ">
            <CollectionFrame className="md:block hidden w-full h-full " />
            <div className=" collectionFramImage absolute ">
              <ImageComponent
                alt={productCollection?.data?.title || ""}
                src={imageSources.src}
                blurDataURL={imageSources.src}
                fallbackSrcs={imageSources.fallbackSrcs}
                placeholder="blur"
                loading="eager"
                fetchPriority="high"
              />
            </div>
          </div>
          <div className="  w-full     flex flex-col justify-center  ">
            <h1 className="headline-md md:headline-lg lg:display-sm text-wrap">
              {productCollection?.data.title}
            </h1>
            <div className="lg:flex md:mt-6 mt-4 gap-x-2 grid grid-cols-3     ">
              {productCollection?.data.count_student ||
              productCollection?.data.count_student ? (
                <DetailHeaderItem
                  title=" دانشجو"
                  icon={Graduated}
                  count={String(productCollection?.data.count_student)}
                  className="order-3 md:order-1"
                />
              ) : null}
              {productCollection?.data.total_time ? (
                <DetailHeaderItem
                  icon={CircleClock}
                  title="ساعت آموزش"
                  count={String(productCollection?.data.total_time_hour)}
                  className="order-2"
                />
              ) : null}
              {productCollection?.data.count_product ||
              productCollection?.data.count_related_landings ? (
                <DetailHeaderItem
                  icon={BookIcon}
                  count={String(
                    productCollection?.data.count_product ||
                      productCollection?.data.count_related_landings
                  )}
                  title={
                    productCollection?.data.count_product
                      ? "عنوان آموزشی"
                      : "موضوع آموزشی"
                  }
                  className="order-1 md:order-3"
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>

      <HowToLearnDetailContent productCollection={productCollection} />
    </div>
  );
};

export default HowToLearnDetailHeader;
